import PageContainer from '../../../../components/common/PageContainer';
import ESRApprovedTable from './Table';

const EJOApprovedAndUnstartedPage = () => {
  return (
    <>
      <PageContainer 
        title='My Dashboard + Tasks' 
        subTitle='My MRRF & JO' 
        submoduleTitle='JO Approved, Unstarted' 
        showDate
      >
        <ESRApprovedTable />
      </PageContainer>
    </>
  );
}

export default EJOApprovedAndUnstartedPage;